import { memo, useEffect, useState } from "react";
import { TableRowProps } from "../../../../types";
import TableCell from "../TableCell";

function TableRow({
  row,
  columns,
  stickyClass = "",
  enableRowDrag,
  onRowDragStart,
  onRowDragOver,
  onRowDrop,
  allowRowExpansion,
  handleRowToggle,
  expandedRows,
  selectRow = (id = "") => {},
  deselectRow = (id = "") => {},
  isRowSelected,
  loading,
  expandArrowIcon,
  settings,
  rowKey
}: TableRowProps) {
  const [rowSelected, setIsRowSelected] = useState<boolean>(isRowSelected);

  useEffect(() => {
    if (row._level === 0) {
      setIsRowSelected(isRowSelected);
    }

    return () => {
      setIsRowSelected(false);
    };
  }, [row._level, isRowSelected]);

  const handleCheckboxChanged = () => {
    if (row._level === 0) {
      if (!rowSelected) {
        selectRow(row.id as string);
      } else {
        deselectRow(row.id as string);
      }
    }
  };

  return (
    <div
      key={row?.[rowKey]}
      className="div-grid-row"
      style={{
        height: settings?.rowHeight || 50,
      }}
    >
      {columns?.map((col, index) =>
        col.field === "selection" && row._level === 0 ? (
          <div
            className="div-grid-cell"
            style={{ width: col.width, minWidth: col.width }}
            key={col.field}
          >
            <input
              type="checkbox"
              checked={rowSelected}
              onChange={handleCheckboxChanged}
              aria-label={`Select row ${row.id}`}
            />
          </div>
        ) : (
          <TableCell
            {...col}
            enableRowDrag={enableRowDrag}
            onRowDragStart={onRowDragStart}
            onRowDragOver={onRowDragOver}
            onRowDrop={onRowDrop}
            columns={columns}
            rowData={row}
            columnData={col}
            handleRowToggle={handleRowToggle}
            index={index}
            expandedRows={expandedRows}
            allowRowExpansion={allowRowExpansion}
            stickyClass={stickyClass}
            rowLevel={row._level}
            loading={loading}
            expandArrowIcon={expandArrowIcon}
            key={col.field}
            settings={settings}
            rowKey={rowKey}
          />
        )
      )}
    </div>
  );
}

export default memo(TableRow);
